import DetailsBookings from './DetailsBookings';
import {
    useGetMemberActiveBookingsMutation,
    useGetMemberFutureBookingsMutation,
    useGetMemberPastBookingsMutation,
    useGetMemberAllBookingsMutation
} from '@services/member/member/member.endpoints';
import { BookingTable } from '@services/member/booking/booking.types';

// « Toutes » reste l'onglet d'ouverture (habitude des opérateurs : la convention d'une
// réservation en cours ou passée doit être visible sans changer d'onglet), puis le même
// vocabulaire et le même ordre que l'écran « Réservations » : à venir, en cours, passées.
export const BookingsTabs = (setActiveTab: (tab: number) => void, onBookingSelect: (booking: BookingTable) => void) => {
    return [
        {
            label: 'Toutes les réservations',
            component: (
                <DetailsBookings key={'all'} mutationHook={useGetMemberAllBookingsMutation} onBookingSelect={onBookingSelect} />
            )
        },
        {
            label: 'Réservations à venir',
            component: (
                <DetailsBookings key={'future'} mutationHook={useGetMemberFutureBookingsMutation} onBookingSelect={onBookingSelect} defaultDirection="asc" />
            )
        },
        {
            label: 'Réservations en cours',
            component: (
                <DetailsBookings key={'active'} mutationHook={useGetMemberActiveBookingsMutation} onBookingSelect={onBookingSelect} defaultDirection="asc" />
            )
        },
        {
            label: 'Réservations passées',
            component: <DetailsBookings key={'past'} mutationHook={useGetMemberPastBookingsMutation} onBookingSelect={onBookingSelect} />
        }
    ];
};
